import Swal from "sweetalert2";
import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";
import { showModal } from "@app/store/modalStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { environment } from "@app/store/envStore.svelte.js";
import { canTranscribeMedia } from "@app/lib/player/mediaSources.js";
import * as m from "@app/paraglide/messages.js";

/**
 * After media import, ask whether to open Automatic Transcription.
 * No-ops when offline or the current media source cannot be transcribed.
 */
export async function promptAutomaticTranscription() {
    if (!environment.online || !canTranscribeMedia(projectState.media)) {
        return;
    }

    const result = await Swal.fire({
        ...SWAL_BASE,
        titleText: m.transcribe_after_import_title(),
        text: m.transcribe_after_import_text(),
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: m.yes(),
        denyButtonText: m.no(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: SWAL_CLASSES.precheck,
    });

    if (result.isConfirmed) {
        showModal("automaticTranscription");
    }
}
